import addDays from "date-fns/addDays";
import format from "date-fns/format";
import { CutoffSelectValue } from "./useCalendarEditState";
import { DayColumn, CalendarEditEntry } from "./types";

export const buildDayColumns = (
  operatingDays: string[],
  weekStart: Date,
): DayColumn[] =>
  operatingDays.map((dayNum) => {
    const date = addDays(weekStart, parseInt(dayNum, 10) - 1);
    return {
      dayNum,
      date,
      label: format(date, "EEE, MMM dd"),
      dateISO: format(date, "yyyy-MM-dd"),
    };
  });

export const buildCalendarEdits = (
  editableRadiologistIds: string[],
  dates: string[],
  getValue: (userId: string, date: string) => CutoffSelectValue,
): CalendarEditEntry[] =>
  editableRadiologistIds.flatMap((userId) =>
    dates.map((date): CalendarEditEntry => {
      const value = getValue(userId, date);
      if (value === "available") {
        return {
          centerUserId: userId,
          date,
          type: "available",
          cutoffMinutesFromMidnight: null,
        };
      }
      if (value === "unavailable") {
        return {
          centerUserId: userId,
          date,
          type: "unavailable",
          cutoffMinutesFromMidnight: null,
        };
      }
      return {
        centerUserId: userId,
        date,
        type: "cutoff_time",
        cutoffMinutesFromMidnight: parseInt(value, 10),
      };
    }),
  );
